module.exports = __webpack_public_path__ + "img/le-havre-logo-icon.42a600b4.png";